/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchProjectPathParams = NonNullable<operations['patchProject']['parameters']['path']>;

export type PatchProjectRequestBody = OperationRequestBodyContent<operations['patchProject']>;

export interface Input extends PatchProjectPathParams {
  apiVersion?: string;
  body: PatchProjectRequestBody;
}

export async function patchProject(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/projects/{projectKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
